import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const PositionedDrawer = (props) => {

  const { position, children } = props;

  const classes = classNames(
    'sui-rounded-base sui-bg-primary sui-shadow-lg sui-overflow-y-auto sui-z-max sui-outline-none sui-max-w-full',
    'md:sui-h-full md:sui-w-auto md:sui-row-start-1 md:sui-row-span-full md:sui-col-span-4',
    {
      'md:sui-col-start-9': position === 'right',
      'md:sui-col-start-1': position === 'left'
    }
  );

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

PositionedDrawer.displayName = 'PositionedDrawer';

PositionedDrawer.propTypes = {
  children: PropTypes.node,
  position: PropTypes.string
};

PositionedDrawer.defaultProps = {
};

export { PositionedDrawer };